import { render, staticRenderFns } from "./VerDetalleCalendarioModal.vue?vue&type=template&id=69a0a04e&"
import script from "./VerDetalleCalendarioModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleCalendarioModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('69a0a04e', component.options)
    } else {
      api.reload('69a0a04e', component.options)
    }
    module.hot.accept("./VerDetalleCalendarioModal.vue?vue&type=template&id=69a0a04e&", function () {
      api.rerender('69a0a04e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Calendarios/VerDetalleCalendarioModal.vue"
export default component.exports